export const TWO_SV_PROFILE_NEXT_ACTIONS = [
  'none',
  'enrol_2sv',
  're_enrol_push',
  'push_reenrolment_required',
  'recover_2sv_method',
];

const DEFAULT_RECOVERY_MESSAGE = 'Set up or recover a usable 2SV method before requiring 2SV at login.';

export const getTwoSvLoginRequirementState = (state = {}) => {
  const enrolled = Boolean(state.enrolled);
  const enforced = Boolean(state.enforced);
  const canEnableForLogin = Boolean(state.canEnableForLogin);
  const nextAction = TWO_SV_PROFILE_NEXT_ACTIONS.includes(state.nextAction)
    ? state.nextAction
    : 'none';
  const recoveryMessage = typeof state.recoveryMessage === 'string' && state.recoveryMessage.trim()
    ? state.recoveryMessage.trim()
    : DEFAULT_RECOVERY_MESSAGE;

  if (enforced) {
    return {
      visible: false,
      disabled: true,
      nextAction,
      recoveryMessage,
      action: 'none',
    };
  }

  if (canEnableForLogin) {
    return {
      visible: true,
      disabled: false,
      nextAction,
      recoveryMessage: '',
      action: 'enable_login',
    };
  }

  if (nextAction === 'enrol_2sv' || !enrolled) {
    return {
      visible: true,
      disabled: true,
      nextAction,
      recoveryMessage,
      action: 'enrol_2sv',
    };
  }

  if (
    nextAction === 're_enrol_push'
    || nextAction === 'push_reenrolment_required'
    || nextAction === 'recover_2sv_method'
  ) {
    return {
      visible: true,
      disabled: true,
      nextAction,
      recoveryMessage,
      action: 'recover_2sv_method',
    };
  }

  return {
    visible: true,
    disabled: true,
    nextAction,
    recoveryMessage,
    action: 'unavailable',
  };
};
